<template>
  <div>
    <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin>
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
        <v-row>
<v-row>
          <v-col cols="12">
            <v-sheet tile height="54" class="d-flex">
              <!-- บริษัท -->
              <v-select
                v-model="Company"
                :items="CompanyItem"
                dense
                outlined
                @change="getDataBranch(Company)"
                hide-details
                clearable
                clear-icon="mdi-close-circle"
                label="บริษัท"
                class="ma-2"
              ></v-select>
              <!-- สาขา -->
              <v-select
                v-model="Branch"
                :items="BranchItem"
                @change="getDataDepartment(Branch)"
                dense
                outlined
                hide-details
                clearable
                clear-icon="mdi-close-circle"
                label="สาขา"
                class="ma-2"
              ></v-select>
              <!-- แผนก -->
              <v-select
                v-model="Department"
                :items="DepartmentItem"
                @change="departmentCheckSearch(Department)"
                dense
                outlined
                hide-details
                clearable
                clear-icon="mdi-close-circle"
                label="แผนก"
                class="ma-2"
              ></v-select>
            </v-sheet>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-sheet tile height="54" class="d-flex">
              <!-- วัน -->
              <v-select
                v-model="day"
                :items="dayName"
                dense
                outlined
                hide-details
                clearable
                clear-icon="mdi-close-circle"
                label="วัน"
                class="ma-2"
              ></v-select>
              <!-- เดือน -->
              <v-select
                v-model="month"
                :items="monthNameTH"
                dense
                outlined
                hide-details
                label="เดือน"
                class="ma-2"
                clearable
                clear-icon="mdi-close-circle"
              ></v-select>
              <!-- ปี -->
              <v-select
                v-model="year"
                :items="yearsNumber"
                dense
                outlined
                hide-details
                label="ปี"
                class="ma-2"
              ></v-select>
              <!-- ค้นหา -->
              <v-btn
                class="mt-2"
                elevation="2"
                color="info"
                text
                @click="getData()"
              >
                <v-icon left>mdi-calendar-search</v-icon>
                ค้นหา
              </v-btn>
            </v-sheet>
          </v-col>
        </v-row>

        <v-row>
          <v-col class="pa-5 ma-2">
            <v-btn
              :loading="!dataReady"
              :disabled="!dataReady"
              color="blue-grey"
              class="white--text"
              @click="exportData()"
            >
              Download
              <v-icon right dark> mdi-cloud-download </v-icon>
            </v-btn>
            <v-btn
              :loading="!dataReady"
              :disabled="!dataReady"
              color="blue-grey"
              class="white--text"
              @click="getData()"
            >
              reload
              <v-icon right dark> mdi-reload </v-icon>
            </v-btn>
          </v-col>
        </v-row>

          <!-- รายละเอียด -->
        <v-dialog v-model="dialog" persistent max-width="80%">
          <v-card>
            <v-card-title>
              <span class="headline">ตรวจสอบข้อมูล</span>
            </v-card-title>
            <v-card-text>
              <v-card>
                <v-row>
                  <v-col>
                    <div class="text-h5 mb-4">*ข้อมูลพนักงาน</div>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr style="background-color: #1b437c">
                            <th class="text-left">ข้อมูล</th>
                            <th class="text-left">รายละเอียด</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>รหัสพนักงาน</td>
                            <td>{{ dateItemInfo.empCode }}</td>
                          </tr>
                          <tr>
                            <td>ชื่อ นามสกุล</td>
                            <td>{{ dateItemInfo.empFull_NameTH }}</td>
                          </tr>
                          <tr>
                            <td>แผนก</td>
                            <td>{{ dateItemInfo.masDepartmentName }}</td>
                          </tr>
                          <tr>
                            <td>สาขา</td>
                            <td>{{ dateItemInfo.masBranchName }}</td>
                          </tr>
                          <tr>
                            <td>บริษัท</td>
                            <td>{{ dateItemInfo.masCompanyName }}</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                  <v-col>
                    <div class="text-h5 mb-4">*ข้อมูลการขอสวัสดิการ</div>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr style="background-color: #1b437c">
                            <th class="text-left">ข้อมูล</th>
                            <th class="text-left">รายละเอียด</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>จำนวนวันลา</td>
                            <td>{{ dateItemInfo.welfareRequest }}</td>
                          </tr>
                          <tr>
                            <td>สถานะ</td>
                            <td v-if="dateItemInfo.welfare_status == 'approve'">ผ่านการอนุมัติ จากผู้จัดการแผนกทรัพยากรบุคคล</td>
                          </tr>
                          <tr>
                            <td>ยอดเบิก</td>
                            <td>{{ dateItemInfo.welfareAmount }}</td>
                          </tr>
                           <tr>
                            <td>ไฟล์แนบ</td>
                            <td></td>
                          </tr>
                           <tr>
                            <td>1</td>
                            <td> <a :href="dateItemInfo.welfareFile"  target="_blank" download v-if="dateItemInfo.welfareFile">
                                <b>[File Download]</b>
                              </a>
                            </td>
                          </tr>
                           <tr>
                            <td>2</td>
                            <td> <a :href="dateItemInfo.welfareFile2"  target="_blank" download v-if="dateItemInfo.welfareFile2">
                                <b>[File Download]</b>
                              </a>
                            </td>
                          </tr>
                           <tr>
                            <td>3</td>
                            <td> <a :href="dateItemInfo.welfareFile3"  target="_blank" download v-if="dateItemInfo.welfareFile3">
                                <b>[File Download]</b>
                              </a>
                            </td>
                          </tr>
                           <tr>
                            <td>4</td>
                            <td> <a :href="dateItemInfo.welfareFile4"  target="_blank" download v-if="dateItemInfo.welfareFile4">
                                <b>[File Download]</b>
                              </a>
                            </td>
                          </tr>
                           <tr>
                            <td>5</td>
                            <td> <a :href="dateItemInfo.welfareFile5"  target="_blank" download v-if="dateItemInfo.welfareFile5">
                                <b>[File Download]</b>
                              </a>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                </v-row>
              </v-card>

              <!-- welfareFileUpdate -->
               <v-card>
                <div class="text-h5 mb-4">*แนบไฟล์</div>
                <v-col>
                  <v-file-input
                    v-model="files"
                    show-size
                    accept="image/*, .pdf"
                    placeholder="แนบไฟล์"
                    outlined
                    dense
                    required
                  ></v-file-input>
                </v-col>
              </v-card>

            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                elevation="2"
                x-large
                color="dark darken-1"
                text
                @click="dialog = false"
              >
                <v-icon left> mdi-minus-box-outline</v-icon>
                ปิด
              </v-btn>
              <v-btn
                elevation="2"
                x-large
                color="success"
                text
                @click="dialog = false, approve(dateItemInfo, 'finish')"
              >
                <v-icon left> mdi-check-circle-outline</v-icon>
                อนุมัติ
              </v-btn>
              <v-btn
                elevation="2"
                x-large
                color="red"
                text
                @click="dialog = false,approve(dateItemInfo, 'unapprove')"
              >
                <v-icon left> mdi-cancel</v-icon>
                ไม่อนุมัติ
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- end รายละเอียด -->

        <!-- รายละเอียด -->
        <v-dialog v-model="dialogView" persistent max-width="80%">
          <v-card>
            <v-card-title>
              <span class="headline">ตรวจสอบข้อมูล</span>
            </v-card-title>
            <v-card-text>
              <v-card>
                <v-row>
                  <v-col>
                    <div class="text-h5 mb-4">*ข้อมูลพนักงาน</div>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr style="background-color: #1b437c">
                            <th class="text-left">ข้อมูล</th>
                            <th class="text-left">รายละเอียด</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>รหัสพนักงาน</td>
                            <td>{{ dateItemInfo.empCode }}</td>
                          </tr>
                          <tr>
                            <td>ชื่อ นามสกุล</td>
                            <td>{{ dateItemInfo.empFull_NameTH }}</td>
                          </tr>
                          <tr>
                            <td>แผนก</td>
                            <td>{{ dateItemInfo.masDepartmentName }}</td>
                          </tr>
                          <tr>
                            <td>สาขา</td>
                            <td>{{ dateItemInfo.masBranchName }}</td>
                          </tr>
                          <tr>
                            <td>บริษัท</td>
                            <td>{{ dateItemInfo.masCompanyName }}</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                  <v-col>
                    <div class="text-h5 mb-4">*ข้อมูลการขอสวัสดิการ</div>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr style="background-color: #1b437c">
                            <th class="text-left">ข้อมูล</th>
                            <th class="text-left">รายละเอียด</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>สวัสดิการ</td>
                            <td>{{ dateItemInfo.welfareRequest }}</td>
                          </tr>
                          <tr>
                            <td>สถานะ</td>
                            <td v-if="dateItemInfo.welfare_status == 'finish'">ส่งอนุมัติ ไปยัง แผนกทรัพยากรบุคคล</td>
                          </tr>
                          <tr>
                            <td>ไฟล์แนบจากบัญชี</td>
                            <td>
                              <a
                                :href="dateItemInfo.welfareFileUpdate"
                                target="_blank"
                                download
                                v-if="dateItemInfo.welfareFileUpdate"
                              >
                                <b>[File Download]</b>
                              </a>
                            </td>
                          </tr>
                          <tr>
                            <td>ไฟล์แนบพนักงาน</td>
                            <td>
                            </td>
                          </tr>
                          <tr>
                            <td>1</td>
                            <td>
                              <a
                                :href="dateItemInfo.welfareFile"
                                target="_blank"
                                download
                                v-if="dateItemInfo.welfareFile && dateItemInfo.welfareFile != 'None'"
                              >
                                <b>[File Download]</b>
                              </a>
                            </td>
                          </tr>
                          <tr>
                            <td>2</td>
                            <td>
                              <a
                                :href="dateItemInfo.welfareFile2"
                                target="_blank"
                                download
                                v-if="dateItemInfo.welfareFile2 && dateItemInfo.welfareFile2 != 'None'"
                              >
                                <b>[File Download]</b>
                              </a>
                            </td>
                          </tr>
                          <tr>
                            <td>3</td>
                            <td>
                              <a
                                :href="dateItemInfo.welfareFile3"
                                target="_blank"
                                download
                                v-if="dateItemInfo.welfareFile3 && dateItemInfo.welfareFile3 != 'None'"
                              >
                                <b>[File Download]</b>
                              </a>
                            </td>
                          </tr>
                          <tr>
                            <td>4</td>
                            <td>
                              <a
                                :href="dateItemInfo.welfareFile4"
                                target="_blank"
                                download
                                v-if="dateItemInfo.welfareFile4 && dateItemInfo.welfareFile4 != 'None'"
                              >
                                <b>[File Download]</b>
                              </a>
                            </td>
                          </tr>
                          <tr>
                            <td>5</td>
                            <td>
                              <a
                                :href="dateItemInfo.welfareFile5"
                                target="_blank"
                                download
                                v-if="dateItemInfo.welfareFile5 && dateItemInfo.welfareFile5 != 'None'"
                              >
                                <b>[File Download]</b>
                              </a>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                </v-row>
              </v-card>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                elevation="2"
                x-large
                color="dark darken-1"
                text
                @click="dialogView = false"
              >
                <v-icon left> mdi-minus-box-outline</v-icon>
                ปิด
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- end รายละเอียด -->

        <!-- รายละเอียด -->
        <v-dialog v-model="dialogFileByemp" persistent max-width="80%">
          <v-card>
            <div class="container d-flex justify-content-center mb-50">
      <div class="row">
        <div class="col-md-12">
          <div class="card" id="invoice">
            <div class="row card-header bg-transparent header-elements-inline">
              <img :src="require('@/assets/Icon/logo_Honda_3D.png')" width="80" height="60">
              <img :src="require('@/assets/Icon/LOGO_VGxLIA.png')" width="80" height="40">
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-sm-12">
                  <div class="mb-4">
                    <div class="text-sm-right">
                      <ul class="list list-unstyled mb-0">
                        <li>
                          วันที่:
                          <span class="font-weight-semibold">
                            {{day}} {{month}} {{year}}</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mb-5 ml-auto">
                  <!-- <span class="text-muted"><u>รายการขอรับสวัสดิการ:</u></span> -->
                  <h6 class="card-title text-center ">แบบฟอร์มขอรับสวัสดิการพนักงาน</h6>
                  <div class="mb-2 ml-auto">
                    <v-simple-table>
                          <thead>
                            <tr style="background-color: #1b437c">
                              <th class="text-center">สาขา</th>
                              <th class="text-center">บริษัท</th>
                              <th class="text-center">ชื่อพนักงาน</th>
                              <th class="text-center">ตำแหน่งงาน</th>
                              <th class="text-center">รายการ</th>
                              <th class="text-center">จำนวนเงิน</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>{{dateItemInfo.masBranchName}}</td>
                              <td>{{dateItemInfo.masCompanyName}}</td>
                              <td>{{dateItemInfo.empFull_NameTH}}</td>
                              <td>{{dateItemInfo.positionName}}</td>
                              <td>{{dateItemInfo.welfareRequest}}</td>
                              <td>{{dateItemInfo.welfareAmount}}</td>
                            </tr>
                          </tbody>
                      </v-simple-table>
                  </div>
              </div>
              <div class="mb-5 ml-auto">
                  <div class="d-flex flex-wrap wmin-md-400">
                     <span class="text-muted">รายการอนุมัติ:</span>
                  </div>
                  <v-row cols="10" class="justify-content-center">
                  <v-col cols="5" class="pr-16 mr-16">
                  <div class=" mt-6 mb-5 text-center">
                    <ul class="list list-unstyled mb-6 text-center">
                      <!-- <img  width="70" height="50"><br> -->
                      <u> _{{dateItemInfo.empFirst_NameTH_GA}}_ </u><br>
                      <li>({{dateItemInfo.empFull_NameTH_GA}})</li><br>
                      <li>{{dateItemInfo.positionName_GA}}</li><br>
                      <li>Prepared</li><br>
                      <li>{{computedDateGA}}</li>
                    </ul>
                  </div>
                    <br />
                    <div class=" mt-6 mb-5 text-center">
                    <ul class="list list-unstyled mb-0 text-center">
                      <!-- <img  width="70" height="50"><br> -->
                      <u> _{{dateItemInfo.empFirst_NameTH_HR}}_ </u><br>
                      <li>({{dateItemInfo.empFull_NameTH_HR}})</li><br>
                      <li>{{dateItemInfo.positionName_HR}}</li><br>
                      <li>Concurred(2)</li><br>
                      <li>{{computedDateHR}}</li>
                    </ul>
                  </div>
                </v-col>
                  <v-col cols="5" class="pl-16 ml-16">
                  <div class=" mt-6 mb-5 text-center">
                    <ul class="list list-unstyled mb-6 text-center">
                      <!-- <img  width="70" height="50"><br> -->
                      <u> _{{dateItemInfo.empFirst_NameTH_MGR}}_ </u><br>
                      <li>({{dateItemInfo.empFull_NameTH_MGR}})</li><br>
                      <li>{{dateItemInfo.positionName_MGR}}</li><br>
                      <li>Concurred(1)</li><br>
                      <li>{{computedDateMGR}}</li>
                    </ul>

                  </div>
                    <br />
                    <div class=" mt-6 mb-5 text-center">
                    <ul class="list list-unstyled mb-0 ml-6 text-center">
                      <!-- <img  width="70" height="50"><br> -->
                      <!-- <u>_ศิริวัลย์_</u><br> -->
                      <!-- <li> _ศิริวัลย์_ </li><br> -->
                      <li>(นางศิริวัลย์ อุชุกานนท์ชัย)</li><br>
                      <li>CEO Board</li><br>
                      <li>Approved</li>
                    </ul>
                  </div>
                </v-col>
                  </v-row>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="text-h5 mb-4 text-center">ดาวน์โหลด ไฟล์แนบ</div>
    <div class="card-body">
      <v-alert
        color="cyan"
        border="left"
        elevation="2"
        colored-border
      >
      {{dateItemInfo.empFull_NameTH}}
      <v-spacer></v-spacer>
        <a :href="dateItemInfo.welfareFile"  target="_blank" download v-if="dateItemInfo.welfareFile && dateItemInfo.welfareFile != 'None'">
          <b>[Download File1]</b>
        </a>
        <a :href="dateItemInfo.welfareFile2"  target="_blank" download v-if="dateItemInfo.welfareFile2 && dateItemInfo.welfareFile2 != 'None'">
          <b>[Download File2]</b>
        </a>
        <a :href="dateItemInfo.welfareFile3"  target="_blank" download v-if="dateItemInfo.welfareFile3 && dateItemInfo.welfareFile3 != 'None'">
          <b>[Download File3]</b>
        </a>
        <a :href="dateItemInfo.welfareFile4"  target="_blank" download v-if="dateItemInfo.welfareFile4 && dateItemInfo.welfareFile4 != 'None'">
          <b>[Download File4]</b>
        </a>
        <a :href="dateItemInfo.welfareFile5"  target="_blank" download v-if="dateItemInfo.welfareFile5 && dateItemInfo.welfareFile5 != 'None'">
          <b>[Download File5]</b>
        </a>
      </v-alert>
    </div>
            <v-card-actions>
              <v-spacer></v-spacer>
              <div class="mr-6">
          <download-button
            class="btn btn-primary"
            dom="#invoice"
            name="สวัสดิการพนักงาน.pdf"
          />
        </div>

              <v-btn
                elevation="2"
                x-large
                color="success"
                text
                @click="dialogFileByemp = false, approve(dateItemInfo, 'waitingApprove')"
              >
                <v-icon left> mdi-check-circle-outline</v-icon>
                ส่ง อนุมัติ
              </v-btn>
              <v-btn
                elevation="2"
                x-large
                color="red"
                text
                @click="dialogFileByemp = false,approve(dateItemInfo, 'unapprove')"
              >
                <v-icon left> mdi-cancel</v-icon>
                ไม่อนุมัติ
              </v-btn>
              <v-btn
                elevation="2"
                x-large
                color="dark darken-1"
                text
                @click="dialogFileByemp = false"
              >
                <v-icon left> mdi-minus-box-outline</v-icon>
                ปิด
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- end รายละเอียด -->

        <!-- รายละเอียด -->
        <v-dialog v-model="dialogFile" persistent max-width="80%">
          <v-card>
            <div class="container d-flex justify-content-center mb-50">
      <div class="row">
        <div class="col-md-12">
          <div class="card" id="invoice">
            <div class="row card-header bg-transparent header-elements-inline">
              <img :src="require('@/assets/Icon/logo_Honda_3D.png')" width="80" height="60">
              <img :src="require('@/assets/Icon/LOGO_VGxLIA.png')" width="80" height="40">
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-sm-12">
                  <div class="mb-4">
                    <div class="text-sm-right">
                      <ul class="list list-unstyled mb-0">
                        <li>
                          วันที่:
                          <span class="font-weight-semibold">
                            {{day}} {{month}} {{year}}</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mb-5 ml-auto">
                  <!-- <span class="text-muted"><u>รายการขอรับสวัสดิการ:</u></span> -->
                  <h6 class="card-title text-center ">แบบฟอร์มขอรับสวัสดิการพนักงาน</h6>
                  <div class="mb-2 ml-auto">
                    <v-simple-table>
                          <thead>
                            <tr style="background-color: #1b437c">
                              <th class="text-center">สาขา</th>
                              <th class="text-center">บริษัท</th>
                              <th class="text-center">ชื่อพนักงาน</th>
                              <th class="text-center">ตำแหน่งงาน</th>
                              <th class="text-center">รายการ</th>
                              <th class="text-center">จำนวนเงิน</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="item in selected" :key="item.welfareID">
                              <td>{{item.masBranchName}}</td>
                              <td>{{item.masCompanyName}}</td>
                              <td>{{item.empFull_NameTH}}</td>
                              <td>{{item.positionName}}</td>
                              <td>{{item.welfareRequest}}</td>
                              <td>{{item.welfareAmount}}</td>
                            </tr>
                          </tbody>
                      </v-simple-table>
                  </div>
              </div>
              <div class="mb-5 ml-auto">
                  <div class="d-flex flex-wrap wmin-md-400">
                     <span class="text-muted">รายการอนุมัติ:</span>
                  </div>
                  <v-row cols="10" class="justify-content-center">
                  <v-col cols="5" class="pr-16 mr-16">
                  <div class=" mt-6 mb-5 text-center">
                    <ul class="list list-unstyled mb-6 text-center">
                      <!-- <img  width="70" height="50"><br> -->
                      <u v-if="selected.length"> _{{selected[1].empFirst_NameTH_GA}}_ </u><br>
                      <li v-if="selected.length">({{selected[1].empFull_NameTH_GA}})</li><br>
                      <li v-if="selected.length">{{selected[1].positionName_GA}}</li><br>
                      <li>Prepared</li><br>
                      <li>{{computedDateGA}}</li>
                    </ul>
                  </div>
                    <br />
                    <div class=" mt-6 mb-5 text-center">
                    <ul class="list list-unstyled mb-0 text-center">
                      <!-- <img  width="70" height="50"><br> -->
                      <u v-if="selected.length"> _{{selected[1].empFirst_NameTH_HR}}_ </u><br>
                      <li v-if="selected.length">({{selected[1].empFull_NameTH_HR}})</li><br>
                      <li v-if="selected.length">{{selected[1].positionName_HR}}</li><br>
                      <li>Concurred(2)</li><br>
                      <li>{{computedDateHR}}</li>
                    </ul>
                  </div>
                </v-col>
                  <v-col cols="5" class="pl-16 ml-16">
                  <div class=" mt-6 mb-5 text-center">
                    <ul class="list list-unstyled mb-6 text-center">
                      <!-- <img  width="70" height="50"><br> -->
                      <u v-if="selected.length"> _{{selected[1].empFirst_NameTH_MGR}}_ </u><br>
                      <li v-if="selected.length">({{selected[1].empFull_NameTH_MGR}})</li><br>
                      <li v-if="selected.length">{{selected[1].positionName_MGR}}</li><br>
                      <li>Concurred(1)</li><br>
                      <li>{{computedDateMGR}}</li>
                    </ul>

                  </div>
                    <br />
                    <div class=" mt-6 mb-5 text-center">
                    <ul class="list list-unstyled mb-0 ml-6 text-center">
                      <!-- <img  width="70" height="50"><br> -->
                      <!-- <u>_ศิริวัลย์_</u><br> -->
                      <!-- <li> _ศิริวัลย์_ </li><br> -->
                      <li>(นางศิริวัลย์ อุชุกานนท์ชัย)</li><br>
                      <li>CEO Board</li><br>
                      <li>Approved</li>
                    </ul>
                  </div>
                </v-col>
                  </v-row>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="text-h5 mb-4 text-center">ดาวน์โหลด ไฟล์แนบ</div>
    <div class="text-center" v-for="item in selected" :key="item.welfareID">
      <v-alert
        color="cyan"
        border="left"
        elevation="2"
        colored-border
      >
      {{item.empFull_NameTH}}
      <v-spacer></v-spacer>
        <a :href="item.welfareFile"  target="_blank" download v-if="item.welfareFile && item.welfareFile != 'None'">
          <b>[Download File1]</b>
        </a>
        <a :href="item.welfareFile2"  target="_blank" download v-if="item.welfareFile2 && item.welfareFile2 != 'None'">
          <b>[Download File2]</b>
        </a>
        <a :href="item.welfareFile3"  target="_blank" download v-if="item.welfareFile3 && item.welfareFile3 != 'None'">
          <b>[Download File3]</b>
        </a>
        <a :href="item.welfareFile4"  target="_blank" download v-if="item.welfareFile4 && item.welfareFile4 != 'None'">
          <b>[Download File4]</b>
        </a>
        <a :href="item.welfareFile5"  target="_blank" download v-if="item.welfareFile5 && item.welfareFile5 != 'None'">
          <b>[Download File5]</b>
        </a>
      </v-alert>
    </div>
            <v-card-actions>
              <v-spacer></v-spacer>
              <div class="mr-6">
          <download-button
            class="btn btn-primary"
            dom="#invoice"
            name="สวัสดิการพนักงาน.pdf"
          />
        </div>

              <v-btn
                elevation="2"
                x-large
                color="success"
                text
                @click="dialogFile = false, approveToCEO(dateItemInfo, 'waitingApprove')"
              >
                <v-icon left> mdi-check-circle-outline</v-icon>
                ส่ง อนุมัติ
              </v-btn>
              <v-btn
                elevation="2"
                x-large
                color="red"
                text
                @click="dialogFile = false,approve(dateItemInfo, 'unapprove')"
              >
                <v-icon left> mdi-cancel</v-icon>
                ไม่อนุมัติ
              </v-btn>
              <v-btn
                elevation="2"
                x-large
                color="dark darken-1"
                text
                @click="dialogFile = false"
              >
                <v-icon left> mdi-minus-box-outline</v-icon>
                ปิด
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- end รายละเอียด -->

        <!-- รายละเอียด -->
        <v-dialog v-model="dialogFileManage" persistent max-width="80%">
          <v-card>
            <div class="container d-flex justify-content-center mb-50">
      <div class="row">
        <div class="col-md-12">
          <div class="card" id="invoice">
            <div class="row card-header bg-transparent header-elements-inline">
              <img :src="require('@/assets/Icon/logo_Honda_3D.png')" width="80" height="60">
              <img :src="require('@/assets/Icon/LOGO_VGxLIA.png')" width="80" height="40">
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-sm-12">
                  <div class="mb-4">
                    <div class="text-sm-right">
                      <ul class="list list-unstyled mb-0">
                        <li>
                          วันที่:
                          <span class="font-weight-semibold">
                            {{day}} {{month}} {{year}}</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mb-5 ml-auto">
                  <h6 class="card-title text-center ">แบบฟอร์มขอรับสวัสดิการพนักงาน</h6>
                  <div class="mb-2 ml-auto">
                    <v-simple-table>
                          <thead>
                            <tr style="background-color: #1b437c">
                              <th class="text-center">สาขา</th>
                              <th class="text-center">บริษัท</th>
                              <th class="text-center">ชื่อพนักงาน</th>
                              <th class="text-center">ตำแหน่งงาน</th>
                              <th class="text-center">รายการ</th>
                              <th class="text-center">จำนวนเงิน</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="item in selected3" :key="item.welfareID">
                              <td>{{item.masBranchName}}</td>
                              <td>{{item.masCompanyName}}</td>
                              <td>{{item.empFull_NameTH}}</td>
                              <td>{{item.positionName}}</td>
                              <td>{{item.welfareRequest}}</td>
                              <td>{{item.welfareAmount}}</td>
                            </tr>
                          </tbody>
                      </v-simple-table>
                  </div>
              </div>
              <div class="mb-5 ml-auto">
                  <div class="d-flex flex-wrap wmin-md-400">
                     <span class="text-muted">รายการอนุมัติ:</span>
                  </div>
                  <v-row cols="10" class="justify-content-center">
                  <v-col cols="5" class="pr-16 mr-16">
                  <div class=" mt-6 mb-5 text-center">
                    <ul class="list list-unstyled mb-6 text-center">
                      <!-- <img  width="70" height="50"><br> -->
                      <u v-if="selected3.length"> _{{selected3[0].empFirst_NameTH_GA}}_ </u><br>
                      <li v-if="selected3.length">({{selected3[0].empFull_NameTH_GA}})</li><br>
                      <li v-if="selected3.length">{{selected3[0].positionName_GA}}</li><br>
                      <li>Prepared</li><br>
                      <li>{{computedDateGA}}</li>
                    </ul>
                  </div>
                    <br />
                    <div class=" mt-6 mb-5 text-center">
                    <ul class="list list-unstyled mb-0 text-center">
                      <!-- <img  width="70" height="50"><br> -->
                      <u v-if="selected3.length"> _{{selected3[0].empFirst_NameTH_HR}}_ </u><br>
                      <li v-if="selected3.length">({{selected3[0].empFull_NameTH_HR}})</li><br>
                      <li v-if="selected3.length">{{selected3[0].positionName_HR}}</li><br>
                      <li>Concurred(2)</li><br>
                      <li>{{computedDateHR}}</li>
                    </ul>
                  </div>
                </v-col>
                  <v-col cols="5" class="pl-16 ml-16">
                  <div class=" mt-6 mb-5 text-center">
                    <ul class="list list-unstyled mb-6 text-center">
                      <!-- <img  width="70" height="50"><br> -->
                      <u v-if="selected3.length"> _{{selected3[0].empFirst_NameTH_MGR}}_ </u><br>
                      <li v-if="selected3.length">({{selected3[0].empFull_NameTH_MGR}})</li><br>
                      <li v-if="selected3.length">{{selected3[0].positionName_MGR}}</li><br>
                      <li>Concurred(1)</li><br>
                      <li>{{computedDateMGR}}</li>
                    </ul>

                  </div>
                    <br />
                    <div class=" mt-6 mb-5 text-center">
                    <ul class="list list-unstyled mb-0 ml-6 text-center">
                      <!-- <img  width="70" height="50"><br> -->
                      <!-- <u>_ศิริวัลย์_</u><br> -->
                      <!-- <li> _ศิริวัลย์_ </li><br> -->
                      <li>(นางศิริวัลย์ อุชุกานนท์ชัย)</li><br>
                      <li>CEO Board</li><br>
                      <li>Approved</li>
                    </ul>
                  </div>
                </v-col>
                  </v-row>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- welfareFileUpdate -->
    <v-card>
                <div class="text-h5 mb-4">*แนบไฟล์</div>
                <v-col>
                  <v-file-input
                    v-model="files"
                    show-size
                    accept="image/*, .pdf"
                    placeholder="แนบไฟล์"
                    outlined
                    dense
                    required
                  ></v-file-input>
                </v-col>
              </v-card>
            <v-card-actions>
              <v-spacer></v-spacer>
              <div class="mr-6">
          <download-button
            class="btn btn-primary"
            dom="#invoice"
            name="สวัสดิการพนักงาน.pdf"
          />
        </div>

              <v-btn
                elevation="2"
                x-large
                color="success"
                text
                @click="dialogFileManage = false, editDataToCEO(dateItemInfo, 'finish')"
              >
                <v-icon left> mdi-check-circle-outline</v-icon>
                อนุมัติ
              </v-btn>
              <v-btn
                elevation="2"
                x-large
                color="red"
                text
                @click="dialogFileManage = false,editDataToCEO(dateItemInfo, 'approve')"
              >
                <v-icon left> mdi-cancel</v-icon>
                ไม่อนุมัติ
              </v-btn>
              <v-btn
                elevation="2"
                x-large
                color="dark darken-1"
                text
                @click="dialogFileManage = false"
              >
                <v-icon left> mdi-minus-box-outline</v-icon>
                ปิด
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- end รายละเอียด -->

        <!-- รายละเอียด -->
        <v-dialog v-model="dialogFileManageView" persistent max-width="80%">
          <v-card>
            <div class="container d-flex justify-content-center mb-50">
      <div class="row">
        <div class="col-md-12">
          <div class="card" id="invoice">
            <div class="row card-header bg-transparent header-elements-inline">
              <img :src="require('@/assets/Icon/logo_Honda_3D.png')" width="80" height="60">
              <img :src="require('@/assets/Icon/LOGO_VGxLIA.png')" width="80" height="40">
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-sm-12">
                  <div class="mb-4">
                    <div class="text-sm-right">
                      <ul class="list list-unstyled mb-0">
                        <li>
                          วันที่:
                          <span class="font-weight-semibold">
                            {{day}} {{month}} {{year}}</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mb-5 ml-auto">
                  <h6 class="card-title text-center ">แบบฟอร์มขอรับสวัสดิการพนักงาน</h6>
                  <div class="mb-2 ml-auto">
                    <v-simple-table>
                          <thead>
                            <tr style="background-color: #1b437c">
                              <th class="text-center">สาขา</th>
                              <th class="text-center">บริษัท</th>
                              <th class="text-center">ชื่อพนักงาน</th>
                              <th class="text-center">ตำแหน่งงาน</th>
                              <th class="text-center">รายการ</th>
                              <th class="text-center">จำนวนเงิน</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>{{dateItemInfo.masBranchName}}</td>
                              <td>{{dateItemInfo.masCompanyName}}</td>
                              <td>{{dateItemInfo.empFull_NameTH}}</td>
                              <td>{{dateItemInfo.positionName}}</td>
                              <td>{{dateItemInfo.welfareRequest}}</td>
                              <td>{{dateItemInfo.welfareAmount}}</td>
                            </tr>
                          </tbody>
                      </v-simple-table>
                  </div>
              </div>
              <div class="mb-5 ml-auto">
                  <div class="d-flex flex-wrap wmin-md-400">
                     <span class="text-muted">รายการอนุมัติ:</span>
                  </div>
                  <v-row cols="10" class="justify-content-center">
                  <v-col cols="5" class="pr-16 mr-16">
                  <div class=" mt-6 mb-5 text-center">
                    <ul class="list list-unstyled mb-6 text-center">
                      <!-- <img  width="70" height="50"><br> -->
                      <u> _{{dateItemInfo.empFirst_NameTH_GA}}_ </u><br>
                      <li>({{dateItemInfo.empFull_NameTH_GA}})</li><br>
                      <li>{{dateItemInfo.positionName_GA}}</li><br>
                      <li>Prepared</li><br>
                      <li>{{computedDateGA}}</li>
                    </ul>
                  </div>
                    <br />
                    <div class=" mt-6 mb-5 text-center">
                    <ul class="list list-unstyled mb-0 text-center">
                      <!-- <img  width="70" height="50"><br> -->
                      <u> _{{dateItemInfo.empFirst_NameTH_HR}}_ </u><br>
                      <li>({{dateItemInfo.empFull_NameTH_HR}})</li><br>
                      <li>{{dateItemInfo.positionName_HR}}</li><br>
                      <li>Concurred(2)</li><br>
                      <li>{{computedDateHR}}</li>
                    </ul>
                  </div>
                </v-col>
                  <v-col cols="5" class="pl-16 ml-16">
                  <div class=" mt-6 mb-5 text-center">
                    <ul class="list list-unstyled mb-6 text-center">
                      <!-- <img  width="70" height="50"><br> -->
                      <u> _{{dateItemInfo.empFirst_NameTH_MGR}}_ </u><br>
                      <li>({{dateItemInfo.empFull_NameTH_MGR}})</li><br>
                      <li>{{dateItemInfo.positionName_MGR}}</li><br>
                      <li>Concurred(1)</li><br>
                      <li>{{computedDateMGR}}</li>
                    </ul>

                  </div>
                    <br />
                    <div class=" mt-6 mb-5 text-center">
                    <ul class="list list-unstyled mb-0 ml-6 text-center">
                      <!-- <img  width="70" height="50"><br> -->
                      <!-- <u>_ศิริวัลย์_</u><br> -->
                      <!-- <li> _ศิริวัลย์_ </li><br> -->
                      <li>(นางศิริวัลย์ อุชุกานนท์ชัย)</li><br>
                      <li>CEO Board</li><br>
                      <li>Approved</li>
                    </ul>
                  </div>
                </v-col>
                  </v-row>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- welfareFileUpdate -->
    <v-card>
                <div class="text-h5 mb-4">*แนบไฟล์</div>
                <v-col>
                  <v-file-input
                    v-model="files"
                    show-size
                    accept="image/*, .pdf"
                    placeholder="แนบไฟล์"
                    outlined
                    dense
                    required
                  ></v-file-input>
                </v-col>
              </v-card>
            <v-card-actions>
              <v-spacer></v-spacer>
              <div class="mr-6">
          <download-button
            class="btn btn-primary"
            dom="#invoice"
            name="สวัสดิการพนักงาน.pdf"
          />
        </div>

              <v-btn
                elevation="2"
                x-large
                color="success"
                text
                @click="dialogFileManageView = false, approve(dateItemInfo, 'finish')"
              >
                <v-icon left> mdi-check-circle-outline</v-icon>
                อนุมัติ
              </v-btn>
              <v-btn
                elevation="2"
                x-large
                color="red"
                text
                @click="dialogFileManageView = false,approve(dateItemInfo, 'approve')"
              >
                <v-icon left> mdi-cancel</v-icon>
                ไม่อนุมัติ
              </v-btn>
              <v-btn
                elevation="2"
                x-large
                color="dark darken-1"
                text
                @click="dialogFileManageView = false"
              >
                <v-icon left> mdi-minus-box-outline</v-icon>
                ปิด
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- end รายละเอียด -->

          <!-- data table -->
          <v-col cols="12">
          <v-alert dense type="info" icon="mdi-file-account">
            รายการ <strong>รอ ตรวจสอบข้อมูล</strong>
          </v-alert>
          <v-card elevation="7" v-if="dataReady">
            <v-toolbar flat>
              <v-spacer></v-spacer>

            <v-btn
                    color="primary"
                    dark
                    class="mb-2"
                    @click="(dialogFile = true) "
                  >
                  <v-icon dark>
                    mdi-tag-plus
                  </v-icon>
                    รวมไฟล์
                  </v-btn>
                </v-toolbar>
            <v-card-text>
              <v-text-field
                v-model="searchAll"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
              <v-data-table
                v-model="selected"
                :headers="columns"
                :items="dataItem"
                :single-select="singleSelect"
                item-key="welfareID"
                show-select
                class="elevation-1"
                :search="searchAll"
                :items-per-page="10"
              >
                <template v-slot:[`item.action`]="{ item }">
                  <v-btn
                    color="info"
                    @click="getDataById(item), (dialogFileByemp = true)"
                  >
                    ตรวจสอบ
                  </v-btn>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
          <div v-if="!dataReady" class="text-center">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
        </v-col>
          <v-col cols="12">
          <v-alert dense type="warning" icon="mdi-file-account">
            รายการ <strong>รอ อนุมัติ จากผู้บริหาร</strong>
          </v-alert>
          <v-card elevation="7" v-if="dataReady">
            <v-toolbar flat>
              <v-spacer></v-spacer>

            <v-btn
                    color="primary"
                    dark
                    class="mb-2"
                    @click="(dialogFileManage = true) "
                  >
                  <v-icon dark>
                    mdi-tag-plus
                  </v-icon>
                    จัดการอนุมัติ
                  </v-btn>
                </v-toolbar>
            <v-card-text>
              <v-text-field
                v-model="searchAll2"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
              <v-data-table
                v-model="selected3"
                :headers="columns"
                :items="dataItemWaitingCEO"
                :single-select="singleSelect"
                item-key="welfareID"
                show-select
                class="elevation-1"
                :search="searchAll2"
                :items-per-page="10"
              >
                <template v-slot:[`item.action`]="{ item }">
                  <v-btn
                    color="info"
                    @click="getDataById(item), (dialogFileManageView = true)"
                  >
                    ตรวจสอบ
                  </v-btn>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
          <div v-if="!dataReady" class="text-center">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
        </v-col>
          <!-- end data table -->
          <v-col cols="12">
          <v-alert dense type="success" icon="mdi-file-account">
            รายการ <strong>อนุมัติ </strong>
          </v-alert>
          <v-card elevation="7" v-if="dataReady">
            <v-card-text>
              <v-text-field
                v-model="searchAll1"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
              <v-data-table
                v-model="selected2"
                :headers="columns"
                :items="dataItemApprove"
                :single-select="singleSelect"
                item-key="welfareID"
                show-select
                class="elevation-1"
                :search="searchAll1"
                :items-per-page="10"
              >
                <template v-slot:[`item.action`]="{ item }">
                  <v-btn
                    color="info"
                    @click="getDataById(item), (dialogView = true)"
                  >
                    ตรวจสอบ
                  </v-btn>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
          <div v-if="!dataReady" class="text-center">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
        </v-col>
          <!-- end data table -->
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import adminLeftMenu from '../../Sidebar.vue' // เมนู
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
import readXlsxFile from 'read-excel-file'
import dayName from '../../../assets/master/Date/day.json'
import monthNameTH from '../../../assets/master/Date/monthNameTH.json'
import yearsNumber from '../../../assets/master/Date/yearsNumber.json'
import DownloadButton from '../Special/DownloadButton.vue'
import moment from 'moment' // แปลง date

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    downloadExcel: JsonExcel,
    XLSX,
    readXlsxFile,
    DownloadButton
  },
  created () {
    setInterval(this.getNowGlobal, 1000)
  },
  computed: {
    computedDateEMP () {
      if (this.selected.welfare_date) {
        let dateThEMP = moment(this.selected.welfare_date)
          .locale('th')
          .add(543, 'year')
          .format('LL')
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.showDateTHEMP = dateThEMP
        return this.showDateTHEMP
      }
    },
    computedDateGA () {
      if (this.LAST_DATE_GA) {
        let dateTh = moment(this.LAST_DATE_GA)
          .locale('th')
          .add(543, 'year')
          .format('LL')
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.showDateTH = dateTh
        return this.showDateTH
      }
    },
    computedDateHR () {
      if (this.selected.LAST_DATE_HR) {
        let dateTh1 = moment(this.selected.LAST_DATE_HR)
          .locale('th')
          .add(543, 'year')
          .format('LL')
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.showDateTH2 = dateTh1
        return this.showDateTH2
      }
    },
    computedDateMGR () {
      if (this.selected.LAST_DATE_MGR) {
        let dateTh2 = moment(this.selected.LAST_DATE_MGR)
          .locale('th')
          .add(543, 'year')
          .format('LL')
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.showDateTH3 = dateTh2
        return this.showDateTH3
      }
    }
  },
  data () {
    return {
      PK: '',
      showDateTH: '',
      showDateTH2: '',
      showDateTH3: '',
      formDataSet: [],
      path: '/welfare/', // Path Model
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'สวัสดิการพนักงาน สำหรับ การเงิน ตรวจสอบ',
          disabled: true,
          href: '/Master/welfareRequest'
        }
      ],
      // End Menu Config
      dataReady: true,
      dateTime: '', // Generate DateTime
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      // Dialog Config ADD EDIT DELETE
      dialog: false,
      dialogView: false,
      dialogFile: false,
      dialogFileByemp: false,
      dialogFileManage: false,
      dialogFileManageView: false,
      // END Dialog Config ADD EDIT DELETE
      session: this.$session.getAll(),
      // Search All
      searchAll: '',
      searchAll1: '',
      searchAll2: '',
      selected: [],
      selected2: [],
      selected3: [],
      singleSelect: false,
      files: null,
      // Data Table Config
      columns: [
        { text: 'รหัสพนักงาน', value: 'empCode' },
        { text: 'พนักงาน', value: 'empFull_NameTH' },
        { text: 'ตำแหน่ง', value: 'positionName' },
        { text: 'สาขา', value: 'masBranchName' },
        { text: 'บริษัท', value: 'masCompanyName' },
        { text: 'สวัสดิการ', value: 'welfareRequest' },
        { text: 'ยอดเบิก', value: 'welfareAmount' },
        { text: 'หมายเหตุ', value: 'welfareRemark' },
        { text: 'วันที่ทำรายการ', value: 'welfare_date' },
        { text: 'Action', value: 'action', sortable: false, align: 'center' }
      ],
      dataItem: [],
      dateItemInfo: [],
      dataItemApprove: [],
      dataItemWaitingCEO: [],
      // End Data Table Config
      json_meta: [
        [
          {
            key: 'charset',
            value: 'utf-8'
          }
        ]
      ],
      // End Export Config
      BranchItem: [], // สาขา
      DepartmentItem: [], // แผนก
      CompanyItem: [], // บริษัท
      Company: '', // บริษัท
      Branch: '', // บริษัท
      Department: '', // บริษัท
      year: '',
      month: '',
      day: '',
      dayName: dayName,
      monthNameTH: monthNameTH,
      yearsNumber: yearsNumber
    }
  },
  async mounted () {
    localStorage.removeItem('dataEdit')
    this.month = this.getMonthTh()
    let date = new Date()
    this.year = moment().format('YYYY')
    // this.month = date.getMonth() + 1
    this.day = date.getDate()
    await this.getData()

    await this.getDataCompany()
    await this.getDataBranch()
    await this.getDataDepartment()
  },
  methods: {
    async getData () {
      await this.getDataWaiting()
      await this.getDataWaitingCEO()
      await this.getDataApprove()
    },
    async getDataWaiting () {
      this.dataItem = []
      this.selected = []

      this.Department = (this.Department) ? this.Department : null
      this.Branch = (this.Branch) ? this.Branch : null
      this.Company = (this.Company) ? this.Company : null
      this.month = this.month ? this.month : null

      var monthSearch =
        this.month !== null
          ? '&welfare_month=' + this.getMonthThToINT(this.month)
          : ''

      var Department = (this.Department !== null) ? '&masDepartmentName=' + this.Department : ''
      var Branch = (this.Branch !== null) ? '&masBranchName=' + this.Branch : ''
      var Company = (this.Company !== null) ? '&masCompanyName=' + this.Company : ''

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/welfare/get?welfare_status=approve' +
          '&welfare_year=' + this.year +
            monthSearch +
            Company + Branch + Department,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          if (response.data) {
            this.dataItem = response.data
          }
          this.dataReady = true
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          this.dataReady = true
        })
    },
    async getDataWaitingCEO () {
      this.dataItemWaitingCEO = []
      this.selected3 = []

      this.Department = (this.Department) ? this.Department : null
      this.Branch = (this.Branch) ? this.Branch : null
      this.Company = (this.Company) ? this.Company : null

      this.month = this.month ? this.month : null

      var monthSearch =
        this.month !== null
          ? '&welfare_month=' + this.getMonthThToINT(this.month)
          : ''

      var Department = (this.Department !== null) ? '&masDepartmentName=' + this.Department : ''
      var Branch = (this.Branch !== null) ? '&masBranchName=' + this.Branch : ''
      var Company = (this.Company !== null) ? '&masCompanyName=' + this.Company : ''

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/welfare/get?welfare_status=waitingApprove' +
          '&welfare_year=' + this.year +
            monthSearch +
            Company + Branch + Department,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          if (response.data) {
            this.dataItemWaitingCEO = response.data
          }
          this.dataReady = true
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          this.dataReady = true
        })
    },
    async getDataApprove () {
      this.dataItemApprove = []
      this.selected2 = []

      this.Department = (this.Department) ? this.Department : null
      this.Branch = (this.Branch) ? this.Branch : null
      this.Company = (this.Company) ? this.Company : null

      this.month = this.month ? this.month : null

      var monthSearch =
        this.month !== null
          ? '&welfare_month=' + this.getMonthThToINT(this.month)
          : ''

      var Department = (this.Department !== null) ? '&masDepartmentName=' + this.Department : ''
      var Branch = (this.Branch !== null) ? '&masBranchName=' + this.Branch : ''
      var Company = (this.Company !== null) ? '&masCompanyName=' + this.Company : ''

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/welfare/get?welfare_status=finish' +
          '&welfare_year=' + this.year +
            monthSearch +
            Company + Branch + Department,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          if (response.data) {
            this.dataItemApprove = response.data
          }
          this.dataReady = true
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          this.dataReady = true
        })
    },
    async getDataById (item) {
      console.log('iem', item)
      console.log('day', this.day)
      console.log('month', this.month)
      console.log('year', this.year)
      let currentMorDateTH = this.day + ' ' + this.month + ' ' + this.year

      console.log('currentMorDateTH', currentMorDateTH)
      this.dateItemInfo = []
      this.dateItemInfo = item
      // this.selected = []
      // this.selected.push(item)
    },
    sendData (item) {
      console.log('day', this.day)
      console.log('month', this.month)
      console.log('year', this.year)
      var currentMorDateTH = this.day + ' ' + this.month + ' ' + this.year

      console.log('currentMorDateTH', currentMorDateTH)
      this.selected = []
      this.selected.push(item)
    },
    async viewEmp (dt) {
      localStorage.setItem('CanEdit', true)
      localStorage.setItem('Page', '/HRM/Welfare/WelfareAccountMoneyManagement')
      localStorage.setItem('dataEdit', JSON.stringify(dt))
      console.log('CanEdit', localStorage.setItem('CanEdit', true))
      console.log('JSON.stringify(dt)', JSON.stringify(dt))
      console.log('dt item', dt)
      console.log('dt', localStorage.setItem('dataEdit', JSON.stringify(dt)))

      // this.$router.push(
      //   '/HRM/Employee/EmployeeInfo'
      // )
    },
    async approve (item, status) {
      console.log('item', item)
      console.log('status', status)
      if (this.files) {
        await this.fileEditUpload()
      }
      this.dataReady = false
      var statusName =
        status === 'finish'
          ? 'อนุมัติ'
          : status === 'unapprove'
            ? 'ไม่อนุมัติ'
            : 'ยกเลิก'
      this.$swal({
        title: 'ท่านต้องการ ' + statusName + ' ใช่หรือไม่',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          this.dataReady = false

          let ds = {
            welfareID: item.welfareID,
            welfare_status: status,
            welfareAmount: item.welfareAmount,
            welfareFileUpdate: item.welfareFileUpdate,
            LAST_USER: this.session.data.userName
          }
          console.log('ds', ds)
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + "/welfare/updateAudit",
              ds,
              {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async (response) => {
              this.$swal('เรียบร้อย', 'ส่งข้อมูลเรียบร้อย', 'success')
              await this.linenotify(item, statusName)
              await this.getData()
              this.clearData()
              this.dataReady = true
            })
        })
        .catch((error) => {
          this.dataReady = false
          this.getData()
          console.log(error)
        })
    },
    async approveToCEO (item, status) {
      console.log('item', item)
      console.log('status', status)
      this.dataReady = false
      var statusName =
        status === 'waitingApprove'
          ? 'ส่ง อนุมัติ'
          : status === 'unapprove'
            ? 'ไม่อนุมัติ'
            : 'ยกเลิก'
      this.$swal({
        title: 'ท่านต้องการ ' + statusName + ' ใช่หรือไม่',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          this.dataReady = false

          var count = this.selected.length
          var i = 0
          await this.selected.forEach(async element => {
            console.log('selected', this.selected)
            console.log('element', element)
            let ds = {
              welfareID: element.welfareID,
              welfare_status: status,
              LAST_USER: this.session.data.userName
            }
            await axios
              .post(
              // eslint-disable-next-line quotes
                this.DNS_IP + "/welfare/updateWaitingApprove",
                ds,
                {
                  headers: {
                    'Application-Key': this.$session.getAll().ApplicationKey
                  }
                }
              )
            i += 1
          })
          if (count === i) {
            await this.clearData()
          }
        })
        .then(async (response) => {
          this.$swal('เรียบร้อย', 'ส่งข้อมูลเรียบร้อย', 'success')
          await this.getData()
          this.clearData()
          this.dataReady = true
        })
        .catch((error) => {
          this.dataReady = false
          this.getData()
          console.log(error)
        })
    },
    async editDataToCEO (item, status) {
      console.log('item', item)
      console.log('status', status)
      if (this.files) {
        await this.fileEditUpload()
      }
      this.dataReady = false
      var statusName =
        status === 'finish'
          ? 'อนุมัติ'
          : status === 'approve'
            ? 'ไม่อนุมัติ'
            : 'ยกเลิก'
      this.$swal({
        title: 'ท่านต้องการ ' + statusName + ' ใช่หรือไม่',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          this.dataReady = false

          var count = this.selected3.length
          var i = 0
          await this.selected3.forEach(async element => {
            console.log('selected', this.selected3)
            console.log('element', element)
            let ds = {
              welfareID: element.welfareID,
              welfare_status: status,
              welfareFileUpdate: item.welfareFileUpdate,
              LAST_USER: this.session.data.userName
            }
            await axios
              .post(
              // eslint-disable-next-line quotes
                this.DNS_IP + "/welfare/updateApprove",
                ds,
                {
                  headers: {
                    'Application-Key': this.$session.getAll().ApplicationKey
                  }
                }
              )
            i += 1
          })
          if (count === i) {
            await this.clearData()
          }
        })
        .then(async (response) => {
          this.$swal('เรียบร้อย', 'ส่งข้อมูลเรียบร้อย', 'success')
          await this.linenotify(this.selected3, statusName)
          await this.getData()
          this.clearData()
          this.dataReady = true
        })
        .catch((error) => {
          this.dataReady = false
          this.getData()
          console.log(error)
        })
    },
    async fileEditUpload () {
      const _this = this
      let params = new FormData()
      params.append('file', _this.files)
      if (_this.files.size < 10000000) {
        try {
          await axios
            .post(_this.DNS_IP_UPLOAD + '/upload', params, {
              headers: {
                'Application-Key': _this.$session.getAll().ApplicationKey,
                Code: this.$session.getAll().data.empCode,
                Topic: 'welfare'
              }
            })
            .then(function (response) {
              console.log('filesEdit', response.data)
              _this.dateItemInfo.welfareFileUpdate =
                _this.DNS_IP_UPLOAD + '/' + response.data
            })
            .catch((error) => {
              alert(error)
              return null
            })
        } catch (error) {
          alert(error)
        }
        console.log('this.filesEdit', _this.files)
        console.log('this.filesEdit', _this.files.size)
      }
    },
    async clearData () {
      this.files = null
    },
    async linenotify (dt, statusName) {
      console.log('dt', dt)
      console.log('statusName', statusName)
      await dt.forEach(async element => {
        var massageNoti = statusName + ' จากบัญชี' +
            '\n' + element.welfareRequest +
            '\nชื่อพนักงาน : ' + element.empFull_NameTH +
            '\nแผนก : ' + element.masDepartmentName +
            '\nสาขา : ' + element.masBranchName +
            '\nบริษัท : ' + element.masCompanyName +
            '\nเบอร์โทรศัพท์ติดต่อ : ' + element.empTel
        let ds = {
          token: 'ykOxnleuJDAAnR6CwdI98b7PJYidormK5ZdvOApt54Q', // token
          message: massageNoti // text
        }
        let url = this.DNS_IP + '/line/hrm_notify'
        await axios.post(url, ds)
      })
    },
    // บริษัท
    async getDataCompany () {
      this.CompanyItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/master_company/getItem",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          console.log('Company', response.data)
          this.dataReady = true
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.text = d.masCompanyName
            s.value = d.masCompanyName
            d = s
            this.CompanyItem.push(d)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    // สาขา
    async getDataBranch () {
      this.BranchItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/master_branch/getItem",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          console.log('Company', response.data)
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.text = d.masBranchName
            s.value = d.masBranchName
            d = s
            this.BranchItem.push(d)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    // แผนก
    async getDataDepartment () {
      this.DepartmentItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/master_department/getItem",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          console.log('getDataDepartment : ', this.DepartmentItem)
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.text = d.masDepartmentName
            s.value = d.masDepartmentName
            d = s
            this.DepartmentItem.push(d)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    departmentCheckSearch (departmentCheckSearch) {
      if (departmentCheckSearch) {
        this.disableSearch = true
      }
    },
    async exportData () {
      var tem1 = []
      var tem2 = []
      var tem3 = []
      this.dataItem.forEach((element) => {
        let s = {
          รหัสพนักงาน: element.empCode,
          ชื่อพนักงาน: element.empFull_NameTH,
          ตำแหน่ง: element.positionName,
          แผนก: element.masDepartmentName,
          สาขา: element.masBranchName,
          สวัสดิการ: element.welfareRequest,
          ยอดเบิก: element.welfareAmount,
          หมายเหตุ: element.welfareRemark,
          วันที่ทำรายการ: element.CREATE_DATE,
          สถานะ: element.welfare_status,
          ไฟล์แนบ1: element.welfareFile,
          ไฟล์แนบ2: element.welfareFile2,
          ไฟล์แนบ3: element.welfareFile3,
          ไฟล์แนบ4: element.welfareFile4,
          ไฟล์แนบ5: element.welfareFile5
        }
        tem1.push(s)
      })
      this.dataItemWaitingCEO.forEach((element) => {
        let s = {
          รหัสพนักงาน: element.empCode,
          ชื่อพนักงาน: element.empFull_NameTH,
          ตำแหน่ง: element.positionName,
          แผนก: element.masDepartmentName,
          สาขา: element.masBranchName,
          สวัสดิการ: element.welfareRequest,
          ยอดเบิก: element.welfareAmount,
          หมายเหตุ: element.welfareRemark,
          วันที่ทำรายการ: element.CREATE_DATE,
          สถานะ: element.welfare_status,
          ไฟล์แนบ1: element.welfareFile,
          ไฟล์แนบ2: element.welfareFile2,
          ไฟล์แนบ3: element.welfareFile3,
          ไฟล์แนบ4: element.welfareFile4,
          ไฟล์แนบ5: element.welfareFile5
        }
        tem2.push(s)
      })
      this.dataItemApprove.forEach((element) => {
        let s = {
          รหัสพนักงาน: element.empCode,
          ชื่อพนักงาน: element.empFull_NameTH,
          ตำแหน่ง: element.positionName,
          แผนก: element.masDepartmentName,
          สาขา: element.masBranchName,
          สวัสดิการ: element.welfareRequest,
          ยอดเบิก: element.welfareAmount,
          หมายเหตุ: element.welfareRemark,
          วันที่ทำรายการ: element.CREATE_DATE,
          สถานะ: element.welfare_status,
          ไฟล์แนบ1: element.welfareFile,
          ไฟล์แนบ2: element.welfareFile2,
          ไฟล์แนบ3: element.welfareFile3,
          ไฟล์แนบ4: element.welfareFile4,
          ไฟล์แนบ5: element.welfareFile5
        }
        tem3.push(s)
      })
      var data = XLSX.utils.json_to_sheet(tem1)
      var dataWaiting = XLSX.utils.json_to_sheet(tem2)
      var dataApprove = XLSX.utils.json_to_sheet(tem3)
      var wb = XLSX.utils.book_new() // make Workbook of Excel
      XLSX.utils.book_append_sheet(wb, data, 'รอตรวจสอบ') // sheetAName is name of Worksheet
      XLSX.utils.book_append_sheet(wb, dataWaiting, 'รออนุมัติ') // sheetAName is name of Worksheet
      XLSX.utils.book_append_sheet(wb, dataApprove, 'อนุมัติ') // sheetAName is name of Worksheet
      this.month = this.getMonthTh()
      let date = new Date()
      this.year = moment().format('YYYY')
      this.day = date.getDate()
      XLSX.writeFile(wb, 'รายการขอสวัสดิการ(' + this.day + ' ' + this.month + ' ' + this.year + ').xls') // name of the file is 'book.xlsx'
    }
  }
}
</script>
<style scope>
.v-data-table-header {
  background-color: #1b437c !important;
}
.table-header {
  background-color: black;
}
table, th, td {
  border:1px solid black;
}
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
h3 {
  text-align: center;
}
.a >>> .ql-align-center {
  text-align: center;
}
.v-subheader {
  color: #c62929 !important;
}
a {
  color: #42b983;
}
#danger {
  color: red;
}
body {
  margin: 0;
  font-family: Roboto, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
    "Segoe UI Symbol", "Noto Color Emoji";
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.5385;
  color: #333;
  text-align: left;
  background-color: #eee;
}

.mt-50 {
  margin-top: 50px;
}

.mb-50 {
  margin-bottom: 50px;
}

.card {
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.1875rem;
}

.card-img-actions {
  position: relative;
}

.card-body {
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  padding: 1.25rem;
  text-align: center;
}

.card-title {
  margin-top: 10px;
  font-size: 17px;
}

.invoice-color {
  color: red !important;
}

.card-header {
  padding: 0.9375rem 1.25rem;
  margin-bottom: 0;
  background-color: rgba(0, 0, 0, 0.02);
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}

a {
  text-decoration: none !important;
}

.btn-light {
  color: #333;
  background-color: #fafafa;
  border-color: #ddd;
}

.header-elements-inline {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}

@media (min-width: 768px) {
  .wmin-md-400 {
    min-width: 400px !important;
  }
}

.btn-primary {
  color: #fff;
  background-color: #2196f3;
}

.btn-labeled > b {
  position: absolute;
  top: -1px;
  background-color: blue;
  display: block;
  line-height: 1;
  padding: 0.62503rem;
}
</style>



// WEBPACK FOOTER //
// src/components/HRM/Welfare/WelfareAccountMoneyManagement.vue